import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Start extends React.Component {
    start() {
        this.props.history.push('/timesince');
    }
    
    render() {
        return (
            <div>
                <h1 className="ec__font__title">Easy EC</h1>
                <p className="ec__font__body">Find emergency contraception the easy way</p>
                <button className="ec__button" onClick={this.start.bind(this)}>Start</button>
            </div>
        )
    }
}

export default Start;


// WEBPACK FOOTER //
// ./src/components/screens/Start.js